<template>

    <div class="form-group uploader-box" :class="{'d-none': disabled && numFiles == 0}">
        <label
            class="btn btn-main btn-rounded btn-sm mx-0"
            title="Adicionar ficheiro"
            data-toggle="tooltip-city"
            v-if="showAddButton">
            <slot name="button"></slot>
            <span>{{multiple ? 'Ficheiros' : 'Ficheiro'}} <i class="pl-1 fas fa-plus"></i></span>
            <input
                ref="inputFile"
                type="file"
                :name="name"
                :accept="acceptTypes"
                :multiple="multiple"
                @change="uploadFieldChange"
            />
        </label>
        <div :class="['d-flex flex-wrap d-sm-inline-flex flex-sm-nowrap', {'flex-md-column': direction == 'vertical'}]">
            <template v-if="showList">
                <div class="item" :class="{'pl-sm-3': showAddButton, 'pr-4': direction == 'horizontal'}" v-for="(item, index) in mutableValue" :key="index">
                    <div v-if="activeEdit"
                        class="delete mr-3 d-inline"
                        @click.prevent="removeFileLoaded(index)">
                        <i class="fas fa-times"></i>
                    </div>
                    <a  @click.prevent="linkToItem(item)" href="#">
                        <i class="far fa-file-alt d-inline"></i><span class="d-inline"> - {{ $t(item[filenameProperty]) }}</span>
                    </a>
                </div>
            </template>
            <small v-if="showHelp && activeEdit && (!mutableValue || mutableValue.length==0)" class="pl-sm-3">
                {{ `Possivel adicionar no máximo ${maxFiles} ficheiros.` }}
            </small>
        </div>
        <small v-if="error" class="d-block invalid-feedback">{{ error }}</small>
    </div>
</template>
<script>
    import mixinGlobal from '@/app/shared/mixins/global';
    import {isURL} from '@config/utils';

    export default {
        mixins: [
            mixinGlobal,
        ],
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            keyFile: {
                type: String,
                default: 'file'
            },
            pathProperty: {
                type: String,
                default: 'url'
            },
            filenameProperty: {
                type: String,
                default: 'name'
            },
            maxFiles: {
                type: Number,
                default: 3
            },
            acceptTypes: {
                type: String,
                default: 'image/*'
            },
            name: {
                type: String,
                default: 'files'
            },
            error: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            showList: {
                type: Boolean,
                default: true
            },
            showHelp: {
                type: Boolean,
                default: true
            },
            extraNewProperties: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            direction: {
                type: String,
                default: 'vertical',
                validator: function (prop) {
                    let valid = [
                        'vertical',
                        'horizontal',
                    ];
                    return valid.includes(prop);
                }
            },
        },
        data() {
            return {
                mutableValue: []
            }
        },
        computed: {
            multiple() {
                return this.maxFiles > 1;
            },
            numFiles() {
                return this.mutableValue.length;
            },
            reachedMaximum() {
                return this.numFiles >= this.maxFiles;
            },
            activeEdit(){
                return !this.disabled;
            },
            showAddButton() {
                return this.activeEdit && !this.reachedMaximum;
            }
        },
        methods: {
            linkToItem: function(item) {
                let link = item ? item[this.pathProperty] || item.path : null;
                if(isURL(link)){
                    window.open(link, '_blank');
                }else if(link){
                    // var link = "data:application/pdf;base64, " + window.atob(res).replace(/[\”]/g, '');
                    fetch(link).then(res => res.blob()).then(res => window.open(URL.createObjectURL(res), '_blank'));
                }
            },
            uploadFieldChange: function(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    return false;
                }
                this.addFiles(files);
            },
            addFiles: function(files) {
                const amount = this.mutableValue.length + files.length;
                if (amount > this.maxFiles) {
                    this.showError('Quantidade máximo de arquivos ultrapassada',this.title);
                    return false;
                }

                for (let i = 0, count = files.length; i < count; i++) {
                    const file = files[i];
                    if(file.size/1024/1024 > this.$root.$env.UPLOAD_MAX) {
                        this.showError('O tamanho máximo do ficheiro é de '+this.$root.$env.UPLOAD_MAX+' MB',this.title);
                        continue;
                    }
                    this.createFile(file);

                    if (!this.multiple) {
                        break;
                    }
                }

                if (this.$refs.inputFile) this.$refs.inputFile.value = [];
            },
            createFile(file) {
                let reader = new FileReader();
                reader.onload = (e) => {
                    let dataURI = e.target.result;
                    if (dataURI) {
                        let _element = {path: dataURI, ...this.extraNewProperties};
                        _element[this.filenameProperty] = file.name;
                        _element[this.keyFile] = file;
                        this.mutableValue.push(_element);
                    }
                };

                reader.onerror = (e) => {
                    console.error("File could not be read! Code " + e.target?.error?.code ?? '');
                };

                // Reading data URIs
                reader.readAsDataURL(file);
            },
            removeFileLoaded: function(index) {
                this.mutableValue.splice(index, 1);
            },
        },
        watch: {
            'value': {
                deep: true,
                immediate: true,
                handler: function(newValue) {
                    this.mutableValue = newValue;
                },
            },
            'mutableValue': {
                deep: true,
                handler: function(newValue) {
                    this.$emit('input', newValue);
                },
            }
        },
    }

</script>

<style scoped lang="scss">
    input[type="file"] {
        position: absolute;
        opacity: 0;
        z-index: -1;
    }

    .uploader-box {
        label {
            position: relative;
            top: auto;
            left: auto;
            transform: none;
        }

        .delete {
            cursor: pointer;
        }

        a span {
            word-break: break-all;
        }
    }

</style>
